import useSWR from "swr";
import { listAvailableSourceColumns } from "./service";
import { UseMdaSourceColumnsModel } from "./types";

const useMdaSourceColumns = (): UseMdaSourceColumnsModel => {
  const { data, error, isLoading, mutate } = useSWR(
    `/mda/spreadsheet/columns`,
    () => listAvailableSourceColumns(),
  );

  return {
    data,
    isLoading,
    error,
    mutate,
  };
};

export default useMdaSourceColumns;
